var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MatchStatsForm, } from "./MatchStatsForm";
import { findPlayerLeagueMatchStatByPlayerAndTeam } from "./utils";
export var LeagueMatchStatsForm = function (_a) {
    var _b, _c;
    var leagueMatch = _a.leagueMatch, onSubmit = _a.onSubmit, homeTeamPlayers = _a.homeTeamPlayers, awayTeamPlayers = _a.awayTeamPlayers, _d = _a.canModifyHomeTeam, canModifyHomeTeam = _d === void 0 ? true : _d, _e = _a.canModifyAwayTeam, canModifyAwayTeam = _e === void 0 ? true : _e, _f = _a.canModifyResult, canModifyResult = _f === void 0 ? true : _f;
    var getPlayerLeagueMatchStat = findPlayerLeagueMatchStatByPlayerAndTeam((leagueMatch === null || leagueMatch === void 0 ? void 0 : leagueMatch.playerLeagueMatchStats) || []);
    var homeTeam = leagueMatch.homeTeam;
    var awayTeam = leagueMatch.awayTeam;
    // Only surface (and submit) teams the user may modify — a manager sees only
    // their own team, the league admin sees both. The backend rejects stats for
    // teams you can't modify, so sending them would fail the whole save.
    var editableHomePlayers = canModifyHomeTeam ? homeTeamPlayers : [];
    var editableAwayPlayers = canModifyAwayTeam ? awayTeamPlayers : [];
    var allPlayers = __spreadArray(__spreadArray([], __read(editableHomePlayers.map(function (p) { return ({
        player: p,
        teamId: homeTeam.id,
    }); })), false), __read(editableAwayPlayers.map(function (p) { return ({
        player: p,
        teamId: awayTeam.id,
    }); })), false);
    var initialPlayerStats = allPlayers.map(function (_a) {
        var _b;
        var player = _a.player, teamId = _a.teamId;
        var playerLeagueMatchStat = getPlayerLeagueMatchStat(player.id, teamId);
        return {
            teamId: teamId,
            playerId: player.id,
            goalsScored: playerLeagueMatchStat === null || playerLeagueMatchStat === void 0 ? void 0 : playerLeagueMatchStat.goalsScored,
            yellowCards: playerLeagueMatchStat === null || playerLeagueMatchStat === void 0 ? void 0 : playerLeagueMatchStat.yellowCards,
            redCards: playerLeagueMatchStat === null || playerLeagueMatchStat === void 0 ? void 0 : playerLeagueMatchStat.redCards,
            id: playerLeagueMatchStat === null || playerLeagueMatchStat === void 0 ? void 0 : playerLeagueMatchStat.id,
            played: playerLeagueMatchStat
                ? (_b = playerLeagueMatchStat.played) !== null && _b !== void 0 ? _b : true
                : false,
        };
    });
    var handleSubmit = function (result, playerStats) {
        var _a, _b;
        var leagueMatchResult = {
            id: (_b = (_a = leagueMatch.leagueMatchResult) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0,
            leagueMatchId: leagueMatch.id,
            homeTeamScore: result.leftTeamScore,
            awayTeamScore: result.rightTeamScore,
        };
        var playerLeagueMatchStats = playerStats
            .filter(function (stat) { return stat.played !== false || stat.id !== undefined; })
            .map(function (stat) {
            var _a;
            return ({
                id: stat.id,
                playerId: stat.playerId,
                teamId: stat.teamId,
                goalsScored: stat.goalsScored,
                yellowCards: stat.yellowCards,
                redCards: stat.redCards,
                played: (_a = stat.played) !== null && _a !== void 0 ? _a : false,
                leagueMatchId: leagueMatch.id,
            });
        });
        onSubmit(leagueMatchResult, playerLeagueMatchStats);
    };
    return (_jsx(MatchStatsForm, { leftTeamName: homeTeam.name, rightTeamName: awayTeam.name, leftTeamPlayers: editableHomePlayers, rightTeamPlayers: editableAwayPlayers, initialLeftScore: (_b = leagueMatch.leagueMatchResult) === null || _b === void 0 ? void 0 : _b.homeTeamScore, initialRightScore: (_c = leagueMatch.leagueMatchResult) === null || _c === void 0 ? void 0 : _c.awayTeamScore, initialPlayerStats: initialPlayerStats, onSubmit: handleSubmit, canModifyLeftTeam: canModifyHomeTeam, canModifyRightTeam: canModifyAwayTeam, canModifyResult: canModifyResult, showPlayedCheckbox: true }));
};
